import styled from "styled-components";
import { Modal, Button } from "antd";

/* ─── Constantes ────────────────────────────────────────────────────── */
const MODAL_HEIGHT = "94vh";
const MODAL_WIDTH_DEFAULT = "1000px";
const MODAL_WIDTH_ALT = "715px";
const FONT_FAMILY = "'Open Sans', sans-serif";
const COLOR_PRIMARY = "#002244";
const COLOR_PRIMARY_ALT = "rgba(17, 167, 217, 1)";
const COLOR_PRIMARY_ALT_HOVER = "rgba(18, 158, 204, 1)";
const COLOR_WHITE = "#ffffff";
const COLOR_APPROVE = "#16a34a";
const COLOR_APPROVE_HOVER = "#15803d";
const COLOR_REJECT = "#991b1b";
const COLOR_REJECT_HOVER = "#7f1d1d";
const COLOR_DELETE = "#0A2342";
const COLOR_DELETE_HOVER = "#001F3F";
const SCROLL_THUMB = "rgba(17, 167, 217, 1)";
const SCROLL_TRACK = "#f1f1f1";
const BORDER_RADIUS_MODAL = "14px";

/* ─── Scroll customizado reutilizável ───────────────────────────────── */
const scrollStyles = `
  &::-webkit-scrollbar { width: 8px; height: 8px; }
  &::-webkit-scrollbar-track { background: ${SCROLL_TRACK}; border-radius: 4px; }
  &::-webkit-scrollbar-thumb {
    background: ${SCROLL_THUMB};
    border-radius: 4px;
    transition: background 0.2s ease;
  }
  &::-webkit-scrollbar-thumb:hover { background: rgba(17, 167, 217, 0.8); }
  &::-webkit-scrollbar-corner { background: ${SCROLL_TRACK}; }
  scrollbar-width: thin;
  scrollbar-color: ${SCROLL_THUMB} ${SCROLL_TRACK};
`;

/* ─── Modal ─────────────────────────────────────────────────────────── */

/** Modal com altura fixa — SEM scroll no modal em si */
export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: ${BORDER_RADIUS_MODAL};
    overflow: hidden;
    width: ${({ alterUx }) =>
      alterUx ? MODAL_WIDTH_ALT : MODAL_WIDTH_DEFAULT} !important;
    height: ${MODAL_HEIGHT};
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    border-top-left-radius: ${BORDER_RADIUS_MODAL};
    border-top-right-radius: ${BORDER_RADIUS_MODAL};
    flex-shrink: 0;
  }

  .ant-modal-footer {
    border-bottom-left-radius: ${BORDER_RADIUS_MODAL};
    border-bottom-right-radius: ${BORDER_RADIUS_MODAL};
    flex-shrink: 0;
  }

  /* Body ocupa espaço restante — SEM scroll */
  .ant-modal-body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0 12px 12px 24px !important;
  }

  .ant-modal-close {
    position: absolute !important;
    width: 24px !important;
    height: 24px !important;
    padding: 0 !important;
    top: 10px !important;
    right: 10px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 1001 !important;
    background: ${COLOR_WHITE} !important;
    border-radius: 50% !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }

  .ant-modal-close-x {
    width: 24px !important;
    height: 24px !important;
    line-height: 24px !important;
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
`;

/** Container interno — SEM scroll, distribui espaço via flex */
export const ScrollableContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ModalHeader = styled.div`
  height: 40px;
  background: ${COLOR_WHITE};
  flex-shrink: 0;
`;

/* ─── Cabeçalho ─────────────────────────────────────────────────────── */

export const Header = styled.div`
  width: 100%;
  min-height: 80px;
  flex-shrink: 0;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;

export const TitleArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  min-height: 60px;
`;

export const Title = styled.div`
  font-family: ${FONT_FAMILY};
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #000000;
  min-width: 0;
  max-width: 100%;
`;

export const Subtitle = styled.div`
  font-family: ${FONT_FAMILY};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #314158;
  padding-left: 5px;
`;

export const DateText = styled.div`
  font-family: ${FONT_FAMILY};
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #6c6c6c;
`;

export const AreaStatusAndDate = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const AreaBusiness = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

/* ─── Preview — SCROLL APENAS AQUI ─────────────────────────────────── */

/** Área de preview de documento único — scroll interno */
export const ViewerArea = styled.div`
  min-height: 400px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  overflow: auto;
  margin-top: 10px;
  max-height: 750px !important;
  ${scrollStyles}
`;

export const PackageItemDownloadWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
`;

/** Lista de pacotes — scroll interno */
export const PackagePreviewList = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 10px;
  padding-right: 4px;
  ${scrollStyles}
`;

export const PackagePreviewItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 12px;
  flex-shrink: 0;
`;

export const PackageItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const PackageItemName = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

export const PackageItemStatusBadge = styled.span`
  display: inline-block;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  background: ${({ $status }) =>
    $status === "APPROVED"
      ? "#DCFCE7"
      : $status === "REJECTED"
      ? "#FEE2E2"
      : "#FEF9C3"};
  color: ${({ $status }) =>
    $status === "APPROVED"
      ? "#16A34A"
      : $status === "REJECTED"
      ? "#DC2626"
      : "#CA8A04"};
`;

export const IFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

/* ─── Rodapé ─────────────────────────────────────────────────────────── */

export const FooterContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
`;

export const InteractionArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DownloadSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ButtonsSection = styled.div`
  display: flex;
  gap: 12px;
`;

export const ViewFooterContainer = styled.div`
  flex-shrink: 0;
  padding-top: 8px;
`;

export const ViewTopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ViewBottomSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
`;

/* ─── Observações ───────────────────────────────────────────────────── */

export const ObservationSection = styled.div`
  font-family: ${FONT_FAMILY};
  width: 100%;
  background: rgba(226, 226, 247, 0.2);
  color: rgba(68, 68, 68, 1);
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  margin-top: 10px;
  padding: 16px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 8px;
  white-space: normal;
  word-break: break-word;

  ${({ IsDoubleLine }) =>
    IsDoubleLine &&
    `
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const ObservationText = styled.span`
  font-weight: 300;
  margin-left: 8px;
`;

export const RejectedText = styled.span`
  font-family: ${FONT_FAMILY};
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: rgba(49, 65, 88, 1);
`;

export const DoubleObservationDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 8px;
`;

/* ─── Botões ─────────────────────────────────────────────────────────── */

export const DownloadLink = styled.a`
  font-family: ${FONT_FAMILY};
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  color: ${({ alterUx }) => (alterUx ? COLOR_PRIMARY_ALT : COLOR_PRIMARY)};
  text-decoration: ${({ alterUx }) => (alterUx ? "underline" : "none")};
  display: flex;
  align-items: center;
  gap: 8px;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ alterUx }) => (alterUx ? "rgb(0, 121, 161)" : COLOR_PRIMARY)};
    text-decoration: ${({ alterUx }) => (alterUx ? "underline" : "none")};
  }

  &:disabled {
    cursor: not-allowed;
    color: #999;
    text-decoration: none;
  }
`;

export const RejectButton = styled(Button)`
  width: 132px;
  height: 32px;
  border-radius: 6px;
  background: ${({ $isDelete }) =>
    $isDelete ? `${COLOR_DELETE} !important` : `${COLOR_REJECT} !important`};
  border-color: ${({ $isDelete }) =>
    $isDelete ? `${COLOR_DELETE} !important` : `${COLOR_REJECT} !important`};
  color: ${COLOR_WHITE} !important;
  font-family: ${FONT_FAMILY};
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-transform: ${({ alterUx }) => (alterUx ? "none" : "uppercase")};
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover,
  &:focus {
    background: ${({ $isDelete }) =>
      $isDelete
        ? `${COLOR_DELETE_HOVER} !important`
        : `${COLOR_REJECT_HOVER} !important`};
    border-color: ${({ $isDelete }) =>
      $isDelete
        ? `${COLOR_DELETE_HOVER} !important`
        : `${COLOR_REJECT_HOVER} !important`};
    color: ${COLOR_WHITE} !important;
  }
`;

export const ApproveButton = styled(Button)`
  width: 132px;
  height: 32px;
  border-radius: 6px;
  background: ${COLOR_APPROVE} !important;
  border-color: ${COLOR_APPROVE} !important;
  color: ${COLOR_WHITE} !important;
  text-transform: ${({ alterUx }) => (alterUx ? "none" : "uppercase")};
  font-family: ${FONT_FAMILY};
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover,
  &:focus {
    background: ${COLOR_APPROVE_HOVER} !important;
    border-color: ${COLOR_APPROVE_HOVER} !important;
    color: ${COLOR_WHITE} !important;
  }
`;

export const ViewCloseButton = styled(Button)`
  width: 112px;
  height: 32px;
  border-radius: 6px;
  background: ${({ alterUx }) =>
    alterUx
      ? `${COLOR_PRIMARY_ALT} !important`
      : `${COLOR_PRIMARY} !important`};
  border-color: ${({ alterUx }) =>
    alterUx
      ? `${COLOR_PRIMARY_ALT} !important`
      : `${COLOR_PRIMARY} !important`};
  color: ${COLOR_WHITE} !important;
  font-family: ${FONT_FAMILY};
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover,
  &:focus {
    background: ${({ alterUx }) =>
      alterUx
        ? `${COLOR_PRIMARY_ALT_HOVER} !important`
        : "rgba(0, 26, 53, 1) !important"};
    border-color: ${({ alterUx }) =>
      alterUx
        ? `${COLOR_PRIMARY_ALT_HOVER} !important`
        : "rgba(0, 26, 53, 1) !important"};
    color: ${COLOR_WHITE} !important;
  }
`;

export const DisplayIcon = styled.div`
  font-family: ${FONT_FAMILY};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 4px;
  min-width: 115px;
  min-height: 30px;
  padding: 4px 8px;

  background: ${({ status }) => {
    if (status === "APPROVED") return "#F8FEFA";
    if (status === "REJECTED") return "#FFF9F9";
    return "none";
  }};

  color: ${({ status }) => {
    if (status === "APPROVED") return "#22C55E";
    if (status === "REJECTED") return "#EF4444";
    return "none";
  }};
`;

export const CloseButton = styled(Button)`
  margin-top: 20px;
  width: 100%;
  height: 40px;
  border-radius: 8px;
  background: ${COLOR_WHITE} !important;
  border-color: #11a7d9 !important;
  color: #11a7d9 !important;
  font-family: ${FONT_FAMILY};
  font-weight: 500;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    color 0.2s ease;

  &:hover,
  &:focus {
    background: #f0f8ff !important;
    border-color: #40a9ff !important;
    color: #40a9ff !important;
  }
`;

export const JustificationSection = styled.div`
  font-family: ${FONT_FAMILY};
  font-size: 14px;
  color: #333;
`;
